import React from "react";
import { Segment, Loader, Progress, Dimmer } from "semantic-ui-react";

export const SyncLoader = ({ progress, text, t }) => (
  <Progress active percent={progress} color="blue">
    {t(text)}
  </Progress>
);



// WEBPACK FOOTER //
// ./src/synchronization/SyncLoader/SyncLoader.js